import BRequest from "../../modules/BRequest";
import BDiaryDay from "./BDiaryDay";
import BDiaryDaySection from "./BDiaryDaySection";

export default class BDiaryDayEntry
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-entry`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("change", (event) => {
			if (event.target.matches(`.profile-entry__checkbox input`)) {
				let input = event.target;
				let entry = new BDiaryDayEntry(event.target.closest(this.selector()));
				input.checked ? entry.setChecked() : entry.unsetChecked();
			}
		});
	}

	getDiaryDay()
	{
		return new BDiaryDay(this.el.closest(".diary-day"));
	}

	getSection()
	{
		return new BDiaryDaySection(this.el.closest(".profile-diary-day-section"));
	}

	getObjectId()
	{
		return parseInt(this.el.dataset.id);
	}

	getDeleteURL()
	{
		return this.el.dataset.deleteUrl;
	}

	hide()
	{
		this.el.setAttribute("hidden", "");
	}

	show()
	{
		this.el.removeAttribute("hidden");
	}

	setProcessing()
	{
		this.el.dataset.processing = 1;
	}

	unsetProcessing()
	{
		this.el.dataset.processing = 0;
	}

	isProcessing()
	{
		return this?.el?.dataset?.processing == 1;
	}

	delete()
	{
		const diaryDay = this.getDiaryDay();
		const method = this.el.dataset?.deleteMethod ?? "POST";

		const url = this.getDeleteURL();
		const data = {
			objectId: this.getObjectId(),
		}

		this.el.remove();
		diaryDay.refreshProgramMeals();

		BRequest.call(method, url, data, { headers: { ...BDiaryDay.getDiaryWebTemplatesMutationHeaders() }}).then(response => {
			if (response.data?.templates?.mealsNutrients != "undefined") {
				diaryDay.getMealsNutrientsContainer().setHtml(response.data.templates.mealsNutrients);
			}

			return BDiaryDay.refreshSidebarAfterMutation(diaryDay);
		});
	}

	setChecked()
	{
		this.el.classList.add("profile-entry--checked");
	}

	unsetChecked()
	{
		this.el.classList.remove("profile-entry--checked");
	}
}
